import { useTranslate } from "ra-core";

import { Skeleton } from "@/components/ui/skeleton";

/** Loading placeholder of the WhatsApp conversation parts (design system: skeleton, never blank). */
export const TimelineSkeleton = ({ rows = 3 }: { rows?: number }) => {
  const translate = useTranslate();
  return (
    <div role="status" aria-busy="true" className="flex flex-col gap-3">
      <span className="sr-only">{translate("crm.common.loading")}</span>
      {Array.from({ length: rows }, (_, index) => (
        <Skeleton
          key={index}
          aria-hidden="true"
          className={index % 2 === 0 ? "h-10 w-3/5" : "h-10 w-2/5 self-end"}
        />
      ))}
    </div>
  );
};
